import {IconType} from '../../atoms/Icon/IconType.enum';
import {ViewerSettingFontItemType} from './ViewerSettingFontItemType.interface';
import {ViewerSettingSpaceColorItemType} from './ViewerSettingSpaceColorItemType.interface';
import {ViewerSettingThemeItemType} from './ViewerSettingThemeItemType.interface';

export const themeItems: ViewerSettingThemeItemType[] = [
  {
    themeColor: 'White',
    onIconType: IconType.ViewerThemeWhiteOnStatic,
    offIconType: IconType.ViewerThemeWhiteOffStatic,
  },
  {
    themeColor: 'LightGray',
    onIconType: IconType.ViewerThemeLightGrayOnStatic,
    offIconType: IconType.ViewerThemeLightGrayOffStatic,
  },
  {
    themeColor: 'DarkGray',
    onIconType: IconType.ViewerThemeDarkGrayOnStatic,
    offIconType: IconType.ViewerThemeDarkGrayOffStatic,
  },
  {
    themeColor: 'Black',
    onIconType: IconType.ViewerThemeBlackOnStatic,
    offIconType: IconType.ViewerThemeBlackOffStatic,
  },
  {
    themeColor: 'Sepia',
    onIconType: IconType.ViewerThemeSepiaOnStatic,
    offIconType: IconType.ViewerThemeSepiaOffStatic,
  },
  {
    themeColor: 'Green',
    onIconType: IconType.ViewerThemeGreenOnStatic,
    offIconType: IconType.ViewerThemeGreenOffStatic,
  },
];

export const themeSpaceItems: ViewerSettingSpaceColorItemType[] = [
  {
    themeColor: 'White',
    onIconType: IconType.ViewerMarginWhiteOnStatic,
    offIconType: IconType.ViewerMarginWhiteOffStatic,
  },

  {
    themeColor: 'Black',
    onIconType: IconType.ViewerMarginBlackOnStatic,
    offIconType: IconType.ViewerMarginBlackOffStatic,
  },
];

export const fontItems: ViewerSettingFontItemType[] = [
  {
    font: 'Gothic',
    onIconType: IconType.ViewerFontGothicOn,
    offIconType: IconType.ViewerFontGothicOff,
  },
  {
    font: 'Batang',
    onIconType: IconType.ViewerFontBatangOn,
    offIconType: IconType.ViewerFontBatangOff,
  },
  {
    font: 'Myungjo',
    onIconType: IconType.ViewerFontMyungjoOn,
    offIconType: IconType.ViewerFontMyungjoOff,
  },
];
